import React, { ComponentProps } from 'react';
import { Column, Flex, IColumnProps } from '@grubhubprod/gh-cookbook-react';

type FlexProps = ComponentProps<typeof Flex>;
export type DataTableCellProps = Omit<IColumnProps, 'gutter'> &
  Partial<Pick<FlexProps, 'justifyContent'>>;

export const DataTableCell: React.FC<DataTableCellProps> = ({
  children,
  phone,
  tablet,
  desktop,
  justifyContent = 'flex-start',
}) => (
  <Column phone={phone} tablet={tablet} desktop={desktop} gutter={12}>
    <Flex
      alignItems="center"
      justifyContent={justifyContent}
      width="100%"
      height="100%"
      style={{
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
      }}
    >
      {children}
    </Flex>
  </Column>
);
